import { c as _c } from "react/compiler-runtime";
import { useCountDownTimer } from "@website/ui/count-down-timer/count-down-timer.hook";
import styles from "@website/ui/count-down-timer/count-down-timer.module.scss";
import { CountDownTimerPropertiesType } from "@website/ui/count-down-timer/count-down-timer.types";
import { FC } from "react";
export const CountDownTimer: FC<CountDownTimerPropertiesType> = properties => {
  const $ = _c(2);
  const {
    containerReference
  } = useCountDownTimer(properties);
  let t0;
  if ($[0] !== containerReference) {
    t0 = <span className={styles.container} ref={containerReference} />;
    $[0] = containerReference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};